import { MatchNode } from "../matchNode";

export default function MatchTree({ projectId, sport, configuration, getContent, setContent, getContentKeys }) {
  return (
    <div style={{ paddingTop: "25px" }}>
      {configuration &&
        configuration.map((item) => (
          <MatchNode
            key={item.contentKey}
            projectId={projectId}
            sport={sport}
            item={item}
            level={1}
            getContent={getContent}
            setContent={setContent}
            getContentKeys={getContentKeys}
          />
        ))}
    </div>
  );
}
